import { createSelector } from 'reselect';
import { getMeta } from '@helpcenter/meta';
import { getEnv, EnvType } from '@atlassian/help-center-common-util/env';
import { Environment } from '@atlassian/proforma-common-core/jira-common-models';

export const proformaEnvironment: Record<EnvType, Environment> = {
    [EnvType.LOCAL]: Environment.LOCAL,
    [EnvType.DEV]: Environment.DEVELOPMENT,
    [EnvType.STAGING]: Environment.STAGING,
    [EnvType.PROD]: Environment.PRODUCTION,
};

export const getProformaSettingsWithoutContext = createSelector(
    () => getMeta('tenant-id'),
    (cloudId) => {
        const templatesService =
            getEnv().environment === EnvType.PROD
                ? 'https://proforma-templates.services.atlassian.com'
                : 'https://proforma-templates.stg.services.atlassian.com';
        return {
            analytics: {},
            flags: {},
            environment: proformaEnvironment[getEnv().environment],
            urls: {
                templatesService,
                api: `/gateway/api/proforma/portal/cloudid/${cloudId || ''}`,
                jira: '',
            },
        };
    }
);
